import { render, staticRenderFns } from "./ReceiveRecordModal.vue?vue&type=template&id=21ddf56c&scoped=true"
import script from "./ReceiveRecordModal.vue?vue&type=script&lang=js"
export * from "./ReceiveRecordModal.vue?vue&type=script&lang=js"
import style0 from "./ReceiveRecordModal.vue?vue&type=style&index=0&id=21ddf56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ddf56c",
  null
  
)

export default component.exports